export class FormWidgetTimeSlots {
    constructor() {
        this.$widget = $('.widget-time-slots');
        this.$table = this.$widget.find('.js-timeslots-table');
        this.$allOptions = this.$widget.find('input[type="radio"]');
        this.$preferredOption = this.$widget.find('.js-preferred-option');
        this.$allOptions.on('change', () => this.toggle());
    }

    /**
     * Toggle the select timeslot box on the contact moment page
     */
    toggle() {
        if(this.$preferredOption.prop('checked') === true){
            this.$table.addClass('widget-time-slots__table-wrapper--open');
        } else {
            this.$table.removeClass('widget-time-slots__table-wrapper--open');
        }
    }
}
